// Mappers: transport LC_* DTOs → domain models for the "Mi equipo" "Resumen del mes"
// filters panel (ASIS-5414). Kept decoupled from the wire shape so the UI never
// depends on backend casing (monthlyCutId, etc.).

import { SPANISH_MONTHS } from '@/api/domains/attendance/mappers/monthlyCuts.mapper';
import type {
  LC_MyTeamMonthlyCutoffItemOut,
  LC_GetMyTeamMonthlyCutoffsListOut,
  MyTeamMonthlyCutoff,
} from '../types/myTeamMonthlyCutoffs.types';


export function mapMyTeamMonthlyCutoff(out: LC_MyTeamMonthlyCutoffItemOut): MyTeamMonthlyCutoff {
  return {
    id: out.monthlyCutId,
    year: out.year,
    // Mismo mapeador Spanish→número que ya usan Mi Asistencia y Conceptos de pago
    // para el mismo formato de mes devuelto por el backend (nombre en español).
    month: SPANISH_MONTHS[out.month] ?? 0,
    description: out.description ?? null,
  };
}

export function mapMyTeamMonthlyCutoffsList(
  out: LC_GetMyTeamMonthlyCutoffsListOut,
): MyTeamMonthlyCutoff[] {
  return (out ?? []).map(mapMyTeamMonthlyCutoff);
}
